import { useEffect, useState } from "react";
import AsideV2 from "../../../components/asidev2/AsideV2";
import "../home/Styles.css";
import { styled } from "styled-components";
import {
  getDocumentsByMonthAndYear,
  getAllDocuments,
  togglePropertyActive,
  toggleDeleteProperty,
  getFavoritedCount,
  getReportedCount,
  getViewsCount,
} from "../../../hooks/firebase";
import theme from "../../../theme";
import Switch from "react-ios-switch";
import { Link } from "react-router-dom";
import HeaderV2 from "../../../components/adminV2/header/Header";


const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  .filter-label {
    font-size: 14px;
    color: #000;
  }

  .date-filters {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  select {
    padding: 5px;
    font-size: 14px;
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;

  button {
    padding: 8px 12px;
    background: ${theme.fontColor.green};
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;

const PropertiesV2 = () => {
  const today = new Date();
  const months = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
  const currentMonth = months[today.getMonth()];
  const currentYear = today.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [showAll, setShowAll] = useState(false);
  const [data, setData] = useState(null);

  // Paginação
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

useEffect(() => {
  const fetchData = async () => {
    let result;
    if (showAll) {
      result = await getAllDocuments();
    } else {
      const monthNumber = months.indexOf(month) + 1;
      result = await getDocumentsByMonthAndYear(monthNumber, year);
    }

    if (result && result.length > 0) {
      const propertyIds = result.map((item) => item.id);

      // pegar favoritos, reports e views em paralelo
      const [favoritedCounts, reportedCounts, viewsCounts] = await Promise.all([
        getFavoritedCount(propertyIds),
        getReportedCount(propertyIds),
        getViewsCount(propertyIds),
      ]);

      // transformar em mapas para lookup rápido
      const favMap = Object.fromEntries(
        favoritedCounts.map((doc) => [doc.id, doc.count])
      );
      const repMap = Object.fromEntries(
        reportedCounts.map((doc) => [doc.id, doc.count])
      );
      const viewsMap = Object.fromEntries(
        viewsCounts.map((doc) => [doc.id, doc.count])
      );

      // injetar counts nos imóveis
      result = result.map((item) => ({
        ...item,
        favorited_count: favMap[item.id] ?? 0,
        reported_count: repMap[item.id] ?? 0,
        views_count: viewsMap[item.id] ?? 0,
      }));
    }

    setData(result);
    setCurrentPage(1);
  };

  fetchData();
}, [month, year, showAll]);


  const handleToggleActive = async (id) => {
    await togglePropertyActive(id);
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, active: !item.active } : item
      )
    );
  };

  const handleToggleDeleted = async (id) => {
    await toggleDeleteProperty(id);
    setData((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              deletedAt: item.deletedAt ? null : true,
              active: !item.active,
            }
          : item
      )
    );
  };

  const paginatedData = data
    ? data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : [];

  const totalPages = data ? Math.ceil(data.length / itemsPerPage) : 0;

  return (
    <div>
      <AsideV2 />
      <main className="main-wrapper p-4">
        <HeaderV2 />
        <FilterContainer>
          <span className="filter-label">{showAll ? "Todos" : "Filtrar"}</span>
          <Switch
            checked={!showAll}
            onChange={() => setShowAll(!showAll)}
            onColor={theme.fontColor.green}
            offColor="#E5E5EA"
          />
          {!showAll && (
            <div className="date-filters">
              <select value={month} onChange={(e) => setMonth(e.target.value)}>
                {months.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
              /
              <select value={year} onChange={(e) => setYear(e.target.value)}>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
          )}
        </FilterContainer>

        <section className="section">
          <div className="container-fluid mt-30">
            <div className="row">
              {paginatedData.length > 0 ? (
                paginatedData.map((property) => (
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6"
                    key={property.id}
                  >
                    <div className="card-style-1 mb-30">
                      {/* <div className="card-meta d-flex align-items-center gap-2 p-2">
                        <div className="image">
                          <img
                            src="/assets/images/cards/card-style-1/admin-1.png"
                            alt=""
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="text">
                          <p className="text-sm text-medium mb-0">
                            Anunciado por: <a href="#0">Corretor</a>
                          </p>
                        </div>
                      </div> */}

                      <div className="card-image">
                        <a href={`/imovel/${property.id}`} target="_blank" >
                          <img
                            src={
                              property.images?.[0] ||
                              "https://via.placeholder.com/600x400?text=Sem+Imagem"
                            }
                            alt="Imagem do imóvel"
                            style={{
                              width: "100%",
                              height: "280px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </a>
                      </div>

                      <div className="card-content p-3">
                        <h4 className="fw-bold mb-2">
                          <a href={`/imovel/${property.id}`} target="_blank" className="text-dark text-decoration-none">
                            {property.street || "Endereço não informado"}
                            {property.neightboard && `, ${property.neightboard}`}
                          </a>
                        </h4>

                        <div className="mt-3">
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <div className="me-3 mb-2">
                              <strong>Cidade:</strong>{" "}
                              <span className="text-muted">
                                {property.city || "-"}
                              </span>
                            </div>

                            <div className="form-check form-check-inline mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`ativoCheck-${property.id}`}
                                checked={property.active}
                                onChange={() => handleToggleActive(property.id)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`ativoCheck-${property.id}`}
                              >
                                Ativo
                              </label>
                            </div>

                            <div className="form-check form-check-inline mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`excluidoCheck-${property.id}`}
                                checked={!!property.deletedAt}
                                onChange={() => handleToggleDeleted(property.id)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`excluidoCheck-${property.id}`}
                              >
                                Excluído
                              </label>
                            </div>
                          </div>

                          <div className="row text-center mb-2">
                            <div className="col-4">
                              <div className="bg-light rounded p-2">
                                <small className="text-muted">Quartos</small>
                                <div>
                                  <strong>{property.bedroom || 0}</strong>
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="bg-light rounded p-2">
                                <small className="text-muted">Banheiros</small>
                                <div>
                                  <strong>{property.bathroom || 0}</strong>
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="bg-light rounded p-2">
                                <small className="text-muted">Garagem</small>
                                <div>
                                  <strong>{property.garage || 0}</strong>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row text-center mb-2">
                            
                            <div className="col-4 mb-2">
                              <div className="bg-light rounded p-2" mt-2>
                                <small className="text-muted">Gostos</small>
                                <div>
                                  <strong>{property.favorited_count || 0}</strong>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 mb-2">
                              <div className="bg-light rounded p-2" mt-2>
                                <small className="text-muted">Denúncias</small>
                                <div>
                                  <strong>{property.reported_count || 0}</strong>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 mb-2">
                              <div className="bg-light rounded p-2" mt-2>
                                <small className="text-muted">Visualizações</small>
                                <div>
                                  <strong>{property.views_count || 0}</strong>
                                </div>
                              </div>
                            </div>
                          </div>

                            <div className="row text-center mb-2">
                              <div className="bg-light rounded p-2 d-inline-block">
                              <small className="text-muted">
                                Valor do imóvel
                              </small>
                              <div>
                                <strong>
                                  R${" "}
                                  {(property.price / 100).toLocaleString(
                                    "pt-BR",
                                    { minimumFractionDigits: 2 }
                                  )}
                                </strong>
                              </div>
                              </div>
                            </div>

                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>Nenhum imóvel encontrado.</p>
              )}
            </div>

            {/* Paginação */}
            {totalPages > 1 && (
              <PaginationWrapper>
                <button
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  disabled={currentPage === 1}
                >
                  Anterior
                </button>
                <span style={{ alignSelf: "center" }}>
                  Página {currentPage} de {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  disabled={currentPage === totalPages}
                >
                  Próxima
                </button>
              </PaginationWrapper>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default PropertiesV2;
